<template>
      <component
            :is="decideComponent"
            class="uyasd3ap"
            :class="[
			{ loading: isLoading },
			{ disabled: isDisabled },
			type,
			size,
			{ 'xs-12': isFullWidth }
		]"
            :href="href"
            :to="to"
            :target="target"
            tabindex="0"
            @click="$emit('click')"
            @focus="$emit('focus')"
            @blur="$emit('blur')"
            :data-fup="`action/${action}`"
      >
            <slot></slot>
            <div class="spinner"></div>
      </component>
</template>

<script>
export default {
	name: "j-button",
	props: {
		type: {
			type: String,
			required: false,
			default: "primary"
		},
		size: {
			required: false,
			default: "medium",
			validator(val) {
				return (
					val === null ||
					[
						"xsmall",
						"small",
						"medium",
						"large",
						"xlarge"
					].includes(val)
				)
			}
		},
		isLoading: {
			type: Boolean,
			required: false,
			default: false
		},
		isDisabled: {
			type: Boolean,
			required: false,
			default: false
		},
		to: {
			type: [String, Object],
			required: false
		},
		href: {
			type: String,
			required: false
		},
		target: {
			type: String,
			default: "_self",
			required: false
		},
		routerTag: {
			type: String,
			required: false,
			default: "router-link"
		},
		isFullWidth: {
			type: Boolean,
			default: false
		},
		action: {
			type: String,
			required: false
		}
	},
	computed: {
		decideComponent() {
			if (this.href) return "a"
			if (this.to) return this.routerTag
			return "button"
		}
	}
}
</script>

<style src="./index.css" scoped />
